import { render } from "./CleaningLogPage.vue?vue&type=template&id=06624f23&scoped=true"
import script from "./CleaningLogPage.vue?vue&type=script&lang=js"
export * from "./CleaningLogPage.vue?vue&type=script&lang=js"

import "./CleaningLogPage.vue?vue&type=style&index=0&id=06624f23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06624f23"]])

export default __exports__